import React from 'react';
import { Link } from '@material-ui/core';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import { mdiAlertCircleOutline } from '@mdi/js';
import { IconSize } from '../../../..';
import { SwitchToContainer, NotificationContainer, NotificationIcon, NotificationButton, Notification } from './lab.styles';
const NOTIFICATION_TEXT = 'Virtual Box is required to be installed.';
export const InstallVirtualBox = ({ isElectron, virtualBoxInstalled, vboxDownloadUrl }) => {
    if (!isElectron || virtualBoxInstalled)
        return null;
    return (React.createElement(SwitchToContainer, { "$isError": true },
        React.createElement(NotificationContainer, null,
            React.createElement(NotificationIcon, { path: mdiAlertCircleOutline, size: IconSize.Medium, "$isError": true }),
            React.createElement(Notification, null, NOTIFICATION_TEXT)),
        React.createElement(Link, { href: vboxDownloadUrl !== null && vboxDownloadUrl !== void 0 ? vboxDownloadUrl : 'https://www.virtualbox.org/', target: "_blank", rel: "noreferrer", color: 'error' },
            React.createElement(NotificationButton, { variant: "text", color: "primary", startIcon: React.createElement(SystemUpdateAltIcon, null), "$isError": true }, "Download here"))));
};
//# sourceMappingURL=InstallVirtualBox.js.map